import type { HotkeyCommand } from "owa-hotkeys";
import getKeyboardShortcutsMode from "owa-hotkeys/lib/utils/getKeyboardShortcutsMode";
import fixUpHotkeyCommand from "owa-hotkeys/lib/utils/fixupHotkeyCommand";
import { convertModeToKey } from "owa-readable-hotkeys/lib/utils/convertModeToKey";
import { convertHotkeyStringToReadableText } from "owa-readable-hotkeys/lib/utils/convertHotkeyStringToReadableText";

export default function getSearchShortcutText(command?: HotkeyCommand): string {
    if (!command) {
        return "";
    }
    const modeKey = convertModeToKey(getKeyboardShortcutsMode());
    const keys = modeKey ? fixUpHotkeyCommand(command)[modeKey] : undefined;
    const shortcuts = (typeof keys === "string" ? [keys] : (keys ?? [])).filter(Boolean);
    const preferredShortcuts = shortcuts.includes("ctrl+e") && shortcuts.includes("alt+q")
        ? shortcuts.filter(key => key === "ctrl+e" || key === "alt+q")
        : shortcuts;
    
    return convertHotkeyStringToReadableText(preferredShortcuts.slice(0, 2), {
        preserveCtrl: command?.preserveCtrl,
    });
}
